import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityCartItemApi } from 'api';

export const findEntityCartItem = createAsyncThunk(
  'entityCartItem/findEntityCartItem',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityCartItemApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityCartItemForCart = createAsyncThunk(
  'entityCartItem/findEntityCartItemForCart',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityCartItemApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityCartItem = createAsyncThunk(
  'entityCartItem/createEntityCartItem',
  async (params: any, { rejectWithValue }) => {
    try {
      const { body, option } = params;
      const response = await EntityCartItemApi.create(body, option);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityCartItem = createAsyncThunk(
  'entityCartItem/updateEntityCartItem',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityCartItemApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityCartItem = createAsyncThunk(
  'entityCartItem/removeEntityCartItem',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityCartItemApi.remove(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  cartItemList: Array<any>;
  list: Array<any>;
}

const initialState: IState = {
  tableList: [],
  cartItemList: [],
  list: [],
};

const entityCartItemSlice = createSlice({
  name: 'entityCartItem',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(findEntityCartItem.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.list = data;
      })
      .addCase(findEntityCartItemForCart.fulfilled, (state, action) => {
        const { data } = action.payload;

        const newData = data.map((item: any) => {
          return {
            ...item,
            key: item.id,
            value: item.id,
            customerProductID: item.proposalItem.customerProductID,
            entityID: item.proposalItem.supplierID,
          };
        });

        state.cartItemList = newData;
      })
      .addCase(removeEntityCartItem.fulfilled, (state, action) => {
        const deleteResult = action.payload;
        const newList = state.list.filter(item => item.id !== deleteResult.id);
        state.list = newList;
      });
  },
});

const { reducer: entityCartItemReducer } = entityCartItemSlice;

export default entityCartItemReducer;
